import { render, staticRenderFns } from "./Lab-report.vue?vue&type=template&id=2e905103"
import script from "./Lab-report.js?vue&type=script&lang=js&external"
export * from "./Lab-report.js?vue&type=script&lang=js&external"
import style0 from "./Lab-report.vue?vue&type=style&index=0&id=2e905103&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports